module.exports = __webpack_public_path__ + "img/step1-03.a9a18f4b.png";